// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    // Store Custom Code
    offset: "1",
    color: "#8C7ED7",
};

export default focus;
